export default "__VITE_ASSET__f730388b__"